import { create } from 'zustand';

interface FeedbackStore {
  isOpen: boolean;
  openFeedback: () => void;
  closeFeedback: () => void;
}

export const useFeedbackStore = create<FeedbackStore>((set) => ({
  isOpen: false,
  openFeedback: () => set({ isOpen: true }),
  closeFeedback: () => set({ isOpen: false }),
}));
